import {
  LBS_TO_TONNES,
  BARLEY_COST_FROM_TONNE_TO_BUSHEL,
  BARLEY_COST_PER_BUSHEL_TO_SILAGE,
} from '../../constants'
import {addDaysToDate, daysBetween} from '../math'
import {feedValuesClosestToDate} from './sharedCalculations'

// MATCHES iOS
export const backgrounderSaleWeight = (backgrounder) => {
  var calcDaysOnFeed = daysOnFeed(backgrounder)
  if (calcDaysOnFeed < 0) {
    calcDaysOnFeed = 0
  }

  return (
    Number(backgrounder.purchaseWeight) +
    Number(backgrounder.avgDailyGain) * calcDaysOnFeed
  )
}

// MATCHES iOS
export const daysOnFeed = (backgrounder) => {
  return daysBetween(backgrounder.purchaseDate, backgrounder.saleDate)
}

// MATCHES iOS
export const backgrounderExpectedSellingPrice = (
  defaults,
  backgrounder,
  dtnFeedData,
  basisValues,
) => {
  const saleWeight = backgrounderSaleWeight(backgrounder)

  const finishDate = backgrounderFinishDate(defaults, backgrounder)

  const {liveCattle, cdn, basisValue} = feedValuesClosestToDate(
    finishDate,
    dtnFeedData,
    basisValues,
  )

  const feedlotCostOfGain = backgrounderFeedlotCostOfGain(
    defaults,
    backgrounder,
  )

  return (
    (Number(defaults.outWeight) /
      100 *
      (Number(liveCattle.lastValue) / Number(cdn.lastValue) +
        Number(basisValue.val)) -
      (Number(defaults.outWeight) - Number(saleWeight)) *
        Number(feedlotCostOfGain)) /
    Number(saleWeight)
  )
}

// MATCHES iOS
export const backgrounderTotalCost = (defaults, backgrounder) => {
  const saleWeight = backgrounderSaleWeight(backgrounder)

  return (
    Number(backgrounder.purchaseWeight) *
      Number(backgrounder.purchasePricePerLb) +
    Number(backgrounder.costOfGain) *
      (Number(saleWeight) - Number(backgrounder.purchaseWeight))
  )
}

// MATCHES iOS
export const backgrounderTotalRevenue = (
  defaults,
  backgrounder,
  dtnFeedData,
  basisValues,
) => {
  const expectedSellingPrice = backgrounderExpectedSellingPrice(
    defaults,
    backgrounder,
    dtnFeedData,
    basisValues,
  )

  const saleWeight = backgrounderSaleWeight(backgrounder)

  return Number(saleWeight) * Number(expectedSellingPrice)
}

// MATCHES iOS
export const backgrounderProfitPerHeader = (
  defaults,
  backgrounder,
  dtnFeedData,
  basisValues,
) => {
  const totalCost = backgrounderTotalCost(defaults, backgrounder)

  const totalRevenue = backgrounderTotalRevenue(
    defaults,
    backgrounder,
    dtnFeedData,
    basisValues,
  )

  return Number(totalRevenue) - Number(totalCost)
}

// MATCHES iOS
const backgrounderFeedlotCostOfGain = (defaults, backgrounder) => {
  const saleWeight = backgrounderSaleWeight(backgrounder)

  const calcDaysOnFeedBackgrounder = backgrounderDaysOnFeed(
    defaults,
    saleWeight,
  )

  const {
    barley,
    barleyCost,
    beddingPerHead,
    deathLossPerHead,
    interestPerHead,
    marketingPerHead,
    outWeight,
    silage,
    supplement,
    supplementCost,
    truckingInPerHead,
    vetAndMedPerHead,
    yardagePerDay,
  } = defaults

  return (
    (Number(calcDaysOnFeedBackgrounder) *
      Number(barley) /
      LBS_TO_TONNES *
      Number(barleyCost) +
      Number(calcDaysOnFeedBackgrounder) *
        Number(barleyCost) /
        BARLEY_COST_FROM_TONNE_TO_BUSHEL *
        BARLEY_COST_PER_BUSHEL_TO_SILAGE *
        Number(silage) /
        LBS_TO_TONNES +
      Number(calcDaysOnFeedBackgrounder) *
        Number(supplement) /
        LBS_TO_TONNES *
        Number(supplementCost) +
      Number(truckingInPerHead) +
      Number(marketingPerHead) +
      Number(yardagePerDay) * Number(calcDaysOnFeedBackgrounder) +
      Number(vetAndMedPerHead) +
      Number(deathLossPerHead) +
      Number(beddingPerHead) +
      Number(interestPerHead)) /
    (Number(outWeight) - Number(saleWeight))
  )
}

// MATCHES iOS
const backgrounderDaysOnFeed = (defaults, saleWeight) => {
  return (
    (Number(defaults.outWeight) - Number(saleWeight)) /
    Number(defaults.avgDailyGain)
  )
}

// MATCHES iOS
export const backgrounderFinishDate = (defaults, backgrounder) => {
  const saleWeight = backgrounderSaleWeight(backgrounder)

  const daysToFinish = Math.floor(
    (Number(defaults.outWeight) - Number(saleWeight)) /
      Number(defaults.avgDailyGain),
  )

  return addDaysToDate(backgrounder.saleDate, daysToFinish)
}



// WEBPACK FOOTER //
// ./src/helpers/calculators/backgrounderCalculations.js